import React, { FC } from 'react';
import styled from 'styled-components';
import { SkeletonBlock, SkeletonFooterBar, SkeletonPageHeader, SkeletonPageShell, SkeletonRow, SkeletonStack } from 'src/components/widgets/skeleton';

const BulkVariationSkeletonShell = styled(SkeletonPageShell).attrs({ $padding: '20px 0 92px' })``;

const BulkVariationSkeletonHeader = styled(SkeletonPageHeader)``;

const BulkVariationSectionSkeleton = styled.div`
    border: 1px solid ${(props) => props.theme.app.borderColor};
    border-radius: 8px;
    background: #ffffff;
    padding: 24px;
    min-width: 0;
`;

const BulkVariationSectionLayout = styled.div`
    display: grid;
    grid-template-columns: minmax(180px, 280px) minmax(0, 1fr);
    gap: 24px;
    min-width: 0;

    @media (max-width: 900px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;

const BulkVariationOptionsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    min-width: 0;

    @media (max-width: 700px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;

const BulkVariationOptionCard = styled.div`
    border: 1px solid ${(props) => props.theme.app.borderColor};
    border-radius: 8px;
    background: #ffffff;
    padding: 16px;
    min-width: 0;
`;

const BulkVariationFooterSkeleton = styled(SkeletonFooterBar)``;

export const BulkVariationPageSkeleton: FC = () => (
    <BulkVariationSkeletonShell aria-hidden='true'>
        <BulkVariationSkeletonHeader>
            <SkeletonStack $gap='8px' $flex='1'>
                <SkeletonBlock $width='min(240px, 100%)' $height='26px' />
                <SkeletonBlock $width='min(520px, 100%)' $height='13px' />
            </SkeletonStack>
            <SkeletonBlock $width='120px' $height='36px' $radius='6px' />
        </BulkVariationSkeletonHeader>
        <SkeletonStack $gap='18px'>
            <BulkVariationSectionSkeleton>
                <BulkVariationSectionLayout>
                    <SkeletonStack $gap='8px'>
                        <SkeletonBlock $width='120px' $height='18px' />
                        <SkeletonBlock $width='80%' $height='12px' />
                    </SkeletonStack>
                    <SkeletonRow $gap='12px'>
                        <SkeletonBlock $width='42px' $height='24px' $radius='12px' />
                        <SkeletonStack $gap='8px' $flex='1'>
                            <SkeletonBlock $width='180px' $height='15px' />
                            <SkeletonBlock $width='min(420px, 100%)' $height='12px' />
                        </SkeletonStack>
                    </SkeletonRow>
                </BulkVariationSectionLayout>
            </BulkVariationSectionSkeleton>
            <BulkVariationSectionSkeleton>
                <BulkVariationSectionLayout>
                    <SkeletonStack $gap='8px'>
                        <SkeletonBlock $width='150px' $height='18px' />
                        <SkeletonBlock $width='82%' $height='12px' />
                    </SkeletonStack>
                    <SkeletonStack $gap='12px'>
                        <SkeletonBlock $height='38px' $radius='6px' />
                        {Array.from({ length: 5 }).map((_, index) => (
                            <SkeletonRow key={index} $gap='10px'>
                                <SkeletonBlock $width='18px' $height='18px' $radius='4px' />
                                <SkeletonBlock $width={index % 2 === 0 ? '220px' : '160px'} $height='14px' />
                            </SkeletonRow>
                        ))}
                    </SkeletonStack>
                </BulkVariationSectionLayout>
            </BulkVariationSectionSkeleton>
            <BulkVariationSectionSkeleton>
                <BulkVariationSectionLayout>
                    <SkeletonStack $gap='8px'>
                        <SkeletonBlock $width='120px' $height='18px' />
                        <SkeletonBlock $width='82%' $height='12px' />
                    </SkeletonStack>
                    <BulkVariationOptionsGrid>
                        {Array.from({ length: 5 }).map((_, index) => (
                            <BulkVariationOptionCard key={index}>
                                <SkeletonStack $gap='10px'>
                                    <SkeletonBlock $width={index % 2 === 0 ? '45%' : '62%'} $height='15px' />
                                    <SkeletonBlock $width='85%' $height='12px' />
                                    <SkeletonBlock $width='56px' $height='24px' $radius='12px' />
                                </SkeletonStack>
                            </BulkVariationOptionCard>
                        ))}
                    </BulkVariationOptionsGrid>
                </BulkVariationSectionLayout>
            </BulkVariationSectionSkeleton>
        </SkeletonStack>
        <BulkVariationFooterSkeleton>
            <SkeletonBlock $width='88px' $height='36px' $radius='6px' />
        </BulkVariationFooterSkeleton>
    </BulkVariationSkeletonShell>
);
